export const Collections = {
  USERS: "users",
  CUSTOMERS: "customers",
  REFERRALS: "referrals",
  PASSES: "passes",
  EVENTS: "events",
  EVENT_PARTNERS: "event_partners",
  EVENT_CHECK_INS: "event_check_ins",
  STATIC: "_static_",
  SPEAKERS: "speakers",
  VENUE: "venues",
  POSTS: "posts",
  NOTIFICATIONS: "notifications",
  FORM_RESPONSES: "form_responses",
  MARKETPLACE: "marketplace",
  DONATION_CART_RESPONSES: "donation_cart",
  PUBLIC_PROFILE_RESPONSE: "public_profile_response",
  VIDEO_RESPONSE: "uploaded_videos",
  MY_SCHEDULES: "my_schedules",
  LIVE_STREAMS: "live_streams",
  CHATS: "chats",
  MESSAGES: "messages",
  PARTICIPANTS: "participants",
  STRIPE: {
    PRODUCTS: "products",
    PRICES: "prices",
  },
  FREE_PASS_APPLICATION: "free_pass_applications",
  PARTNER_CHECKLIST: "partner_checklist",
  PARTNER_CHECKLIST_SPACES: "partner_checklist_spaces",
  CTRIBE_DOCUMENTS: "ctribe_documents",
  CTRIBE_DOCUMENT_SPACES: "ctribe_document_spaces",
  SPACE_FOLDERS: "space_folders",
  SPACE_PARTICIPANTS: "space_participants",
  GET_INVOLVED_FORMS: "get_involved_forms",
  EXTENDED_INPUTS: "extended_inputs",
  PASS_EVENTS: "pass_events",
  HOTELS: "hotels",
  HOTEL_BOOKINGS: "hotel_bookings",
  CONTEST_ENTRIES: "contest-entries",
  ORDERS: "orders",

  // CT Chat - LLM Conversational Sales Assistant
  CT_CHAT: {
    SESSIONS: "ct_chat_sessions",
    MESSAGES: "messages", // Subcollection under sessions
    LEADS: "ct_chat_leads",
    OVERRIDES: "ct_chat_overrides",
    KNOWN_MISTAKES: "ct_chat_known_mistakes",
    ANALYTICS: "ct_chat_analytics",
  },

  // Kanban - ClickUp-Style Project Management
  KANBAN: {
    WORKSPACES: "kanban_workspaces",
    SPACES: "spaces", // Subcollection under workspaces
    LISTS: "lists", // Subcollection under spaces
    TASKS: "kanban_tasks", // Root-level for cross-workspace queries
    COMMENTS: "comments", // Subcollection under tasks
    ATTACHMENTS: "attachments", // Subcollection under tasks
    ACTIVITY: "activity", // Subcollection under tasks
    INVITES: "invites", // Subcollection under workspaces
  },
};

export const StaticDocuments = {
  CATEGORIES: "categories",
};

export const StorageFodlers = {
  CTRIBE_DOCUMENTS: "ctribe_documents",
};
